import { useEffect } from "react";
import { useColorModeValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import environment, { getAppValue } from "src/utils/environment";
import { useControls } from "src/utils/createControls";
import Dialog from "src/components/Dialog";
import { ReactComponent as BarkioLightBadge } from "./icons/light-barkio-badge.svg";
import { ReactComponent as BarkioDarkBadge } from "./icons/dark-barkio-badge.svg";
import { ReactComponent as BibinoLightBadge } from "./icons/light-bibino-badge.svg";
import { ReactComponent as BibinoDarkBadge } from "./icons/dark-bibino-badge.svg";
import appUpdater from "./appUpdater";

export default function UpdateNotifier() {
  const { t } = useTranslation();
  const { close, open, isOpen } = useControls(!appUpdater.getIsCurrent());
  const barkioIcon = useColorModeValue(BarkioLightBadge, BarkioDarkBadge);
  const bibinoIcon = useColorModeValue(BibinoLightBadge, BibinoDarkBadge);

  const barkioIconBg = useColorModeValue("black4", "white8");

  useEffect(() => {
    document.addEventListener("new-version-available", open);
    return () => document.removeEventListener("new-version-available", open);
  }, [open]);

  if (!environment.isBrowser) return null;
  const restartApp = () => window.location.reload();
  return (
    <Dialog
      iconBg={getAppValue({ bibino: "primaryLight", barkio: barkioIconBg })}
      icon={getAppValue({ bibino: bibinoIcon, barkio: barkioIcon })}
      heading={t("newVersionAvailable.heading")}
      text={t("newVersionAvailable.text")}
      type="unset"
      buttons={[
        { text: t("remindMeLater"), onClick: close },
        { text: t("reloadPage"), onClick: restartApp }
      ]}
      isOpen={isOpen}
      onClose={close}
      onConfirm={restartApp}
    />
  );
}
